var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@digitools/honest-react';
import FocusLock from 'react-focus-lock';
import { FocusOn } from 'react-focus-on';
import styled from 'styled-components';
var StyledOverlay = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background: rgba(0, 0, 0, 0.85);\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  position: fixed;\n  text-align: center;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: 100;\n"], ["\n  align-items: center;\n  background: rgba(0, 0, 0, 0.85);\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  position: fixed;\n  text-align: center;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: 100;\n"])));
var StyledToothIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 70px;\n  font-weight: bold;\n"], ["\n  font-size: 70px;\n  font-weight: bold;\n"])));
var StyledItemsContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 4rem;\n  max-width: 75rem;\n"], ["\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 4rem;\n  max-width: 75rem;\n"])));
var StyledParagraph = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", "\n  font-size: 2.125rem;\n  font-weight: 500;\n  line-height: 3rem;\n\n  small {\n    display: block;\n    font-size: 1.5rem;\n    color: white;\n    font-weight: 400;\n    margin-top: 1rem;\n\n    a {\n      font-size: 1.5rem;\n      color: ", "\n      font-weight: 400;\n    }\n  }\n"], ["\n  color: ", "\n  font-size: 2.125rem;\n  font-weight: 500;\n  line-height: 3rem;\n\n  small {\n    display: block;\n    font-size: 1.5rem;\n    color: white;\n    font-weight: 400;\n    margin-top: 1rem;\n\n    a {\n      font-size: 1.5rem;\n      color: ", "\n      font-weight: 400;\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return "".concat(theme.palette.warningLightest);
}, function (_a) {
  var theme = _a.theme;
  return "".concat(theme.palette.secondaryLighter);
});
var SystemDownOverlay = function () {
  return _jsx(FocusOn, {
    children: _jsx(FocusLock, {
      children: _jsx(StyledOverlay, __assign({
        "aria-describedby": 'overlay-description',
        "aria-labelledby": 'overlay-title',
        "aria-modal": true,
        id: 'system-down-overlay',
        "data-public": true,
        "data-testid": 'system-down-overlay',
        role: 'dialog'
      }, {
        children: _jsxs(StyledItemsContainer, {
          children: [_jsx(StyledToothIcon, {
            name: 'tooth',
            color: 'white',
            size: 'extraLarge'
          }), _jsx(StyledParagraph, __assign({
            id: 'overlay-title'
          }, {
            children: "The Dental Provider Portal is currently unavailable. We are working to restore access as soon as possible. Please check back soon."
          }))]
        })
      }))
    })
  });
};
export default SystemDownOverlay;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;